const $ = require('jquery');

global.jQuery = global.$ = $

const bootstrap = require('bootstrap');

const Genetic = require('genetic-js');

window.PlotlyConfig = {MathJaxConfig: 'local'};
const Plotly = require('plotly.js-dist');
const mathjs = require('mathjs');

const moneyValues = [2, 1, 0.5, 0.2, 0.1, 0.05];

var amount;
$('#amountInput').change(function () {
  amount = this.value;
}).change();


var g = Genetic.create();
g.optimize = Genetic.Optimize.Minimize;

function addOptionsFromObject(select, object) {
  for (var key in object){
    select.append($('<option>', {value: key, text: key}));
  }
}
addOptionsFromObject($('#selection1TypeInput'), Genetic.Select1);
addOptionsFromObject($('#selection2TypeInput'), Genetic.Select2);

$('#selection1TypeInput').change(function () {
  g.select1 = Genetic.Select1[this.value];
}).change();

$('#selection2TypeInput').change(function () {
  g.select2 = Genetic.Select2[this.value];
}).change();

g.seed = function() {
  var numDenominations = moneyValues.length;
  return mathjs.floor(mathjs.random([numDenominations], 0, 10));
}

function makeMutationFun (maxDriftInput){
  var maxDrift = maxDriftInput;
  return function(entity) {
    var drift = mathjs.pickRandom(mathjs.range(-4,4));

    var i = mathjs.randomInt(entity.length);
    entity[i] += drift;
    entity[i] = Math.max(0, entity[i]);
    return entity;
  }
}

$('#mutationDriftInput').change(function(){
  g.mutate = makeMutationFun(+(this.value));
}).change();

g.crossover = function(mother, father) {
  // uniform crossover / discrete recombination
  var len = mother.length;
  var mask = mathjs.randomInt([len],2);
  var son = [].concat(father);
  var daughter = [].concat(mother);
  for (var i=0; i < len; i++) {
    if (mask[i]){
      son[i] = mother[i];
      daughter[i] = father[i];
    }
  }

  return [son, daughter];
};

g.fitness = function(entity) {
  const epsilon = 0.00001;
  var numCoins = mathjs.sum(entity);
  var fitnessVal = numCoins;
  var value = mathjs.dot(moneyValues, entity);
  var diff = Math.abs(value - amount);
  var p = 2;
  var r = 1.5 / Math.pow(0.05, p);
  fitnessVal += r * Math.pow(Math.max(0, (diff - epsilon)), p);
  return fitnessVal;
};

var maxIterations;
var populationHistory = [];
g.notification = function(pop, generation, stats, isFinished) {
  console.log("generation: " + generation);
  populationHistory.push({
    population: pop,
    generation: generation
  });

  //update progressbar
  var progress = Math.floor((generation / maxIterations) * 100);
  $('#evolution-progress > .progress-bar').css('width', progress.toString()+"%");

  showSolution(pop[0].entity);

  if (isFinished) {
    console.log("Finished!");
    $('#evolution-progress > .progress-bar').css('width', "100%");
    $('#evolution-progress').collapse('hide');

    fittestIndividual = pop[0];
    console.log('winning individual ' + fittestIndividual.entity);
    console.log('final amount ' + mathjs.dot(fittestIndividual.entity, moneyValues));
    plotBestFitPerGeneration($('#bestFitPerGeneration').get(0), populationHistory);
    $('#solve').prop( "disabled", false );
    $('#solve > span').collapse('hide');
    $('#solution-card').collapse('show');

    $('#final-generation > b').html(generation + 1);
    $('#bestfit > b').html(pop[0].fitness.toPrecision(4));
    $('#avg-fitness > b').html(stats.mean.toPrecision(4));
    $('#std-fitness > b').html(stats.stdev.toPrecision(4));
  }
};

function showSolution(entity) {
  var spans = $('#changeResult .moneyUnit');
  for (var i = 0; i < entity.length; i++){
    $(spans[i]).html($('<b>',{html: entity[i]}));
  }

}

function plotBestFitPerGeneration (plotDiv, populationHistory){

  var traces = {
    x: populationHistory.map(function (val) {return val.generation}),
    y: populationHistory.map(function (val) {return val.population[0].fitness}),
    mode: 'lines'
  };
  var layout = {
    title: 'Error per Generation',
    'xaxis': {
      title: 'generation'
    },
    'yaxis': {
      title: 'error'
    }
  };
  Plotly.newPlot(plotDiv, [traces], layout);
}

function getConfigFromForm(){
  const iterationsToSkipNotification = 10;
  maxIterations = parseInt($('#numIterationsInput').val());
  return {
    "iterations": maxIterations,
    "size": parseInt($('#populationSizeInput').val()),
    "crossover": +($('#crossoverProbabilityInput').val()),
    "mutation": +($('#mutationProbabilityInput').val()),
    webWorkers: false,
    "skip": iterationsToSkipNotification
  };
}

$('#solve').click(function() {
  var config = getConfigFromForm();
  var userData = {
    initBounds: [-5,5],
    amount: amount
  };

  $('#solve').prop("disabled", true);
  $('#solution-card').prev('p').collapse('hide');
  $('#solve > span').collapse('show');
  $('#evolution-progress').collapse('show');
  $('#evolution-progress').one('shown.bs.collapse', () => {
    populationHistory = [];
    g.entities = [];
    g.evolve(config, userData);
  });
});

//$('#restart').click(function(){
//  makeAndPlotDataset();
//});
